// Custom Modal Handler
(() => {
  const MODAL_SELECTOR = '.custom-modal-wrapper';
  const CLOSE_SELECTOR = '.custom-modal__close, .gift-modal__button';

  function getModal() {
    return document.querySelector(MODAL_SELECTOR);
  }

  function showModal() {
    const modal = getModal();
    if (!modal) return;

    modal.style.display = 'flex';
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';

    // Focus trap
    const focusableElements = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  }

  function hideModal() {
    const modal = getModal();
    if (!modal) return;

    modal.style.display = 'none';
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }

  function setupEventListeners() {
    const modal = getModal();
    if (!modal) return;

    // Close buttons
    const closeButtons = modal.querySelectorAll(CLOSE_SELECTOR);
    closeButtons.forEach((button) => {
      button.addEventListener('click', hideModal);
    });

    // Close on backdrop click
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        hideModal();
      }
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        hideModal();
      }
    });
  }

  // Expose show function globally for trigger buttons
  window.showCustomModal = showModal;
  window.hideCustomModal = hideModal;

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupEventListeners);
  } else {
    setupEventListeners();
  }
})();
